import React from 'react';
import { CURRENCY_USD } from 'constants/currency';
import { getCurrencySymbol } from 'utils/shared/money/getCurrencySymbol';
import Star from 'svg/Star';
import VideoCamera from 'svg/VideoCamera';
import Button from 'components/Button';
import classNames from 'styles/utils/classNames';
import InfoItem from './InfoItem';

interface RemoteCoachingCardProps {
  responseTime: string;
  rating?: number;
  reviewCount: number;
  price: number;
  currency: string;
  handleGetStarted: (event?: React.MouseEvent<HTMLButtonElement>) => void;
}

const RemoteCoachingCard: React.FC<RemoteCoachingCardProps> = ({
  responseTime,
  rating,
  reviewCount,
  price,
  currency,
  handleGetStarted,
}) => {
  return (
    <>
      <section className="flex max-w-full flex-col overflow-hidden rounded-xl bg-color-bg-lightmode-brand-secondary dark:bg-color-bg-darkmode-brand-secondary max-md:px-5 xs:p-4 md:p-6">
        <div
          className={classNames(
            'flex max-w-full flex-wrap justify-center text-color-text-brand xs:w-full xs:flex-col md:flex-row lg:w-fit',
            !!rating ? 'xs:gap-6 md:gap-12' : 'xs:gap-8 md:gap-20',
          )}
        >
          <div className="flex items-start gap-4 self-start">
            <VideoCamera className="h-6 w-6 text-color-text-brand" />
            <div className="flex flex-col justify-center xs:w-full md:w-[10.688rem]">
              <h2 className="md:typography-product-heading-compact xs:typography-product-subheading text-color-text-brand dark:text-color-text-brand">
                Remote coaching
              </h2>
              <p className="typography-product-chips-filters mt-1 text-color-text-brand dark:text-color-text-brand ">
                Video analysis : submit a video for point-by-point feedback.
              </p>
            </div>
          </div>

          <div
            className={classNames(
              'flex flex-row justify-center xs:gap-16 md:gap-11',
              !!rating ? 'xs:gap-10 md:gap-11' : 'xs:gap-8 md:gap-16',
            )}
          >
            <div className="h-[4.75rem] w-0 shrink-0 border border-brand-fire-200 dark:border-brand-fire-200 xs:hidden md:flex lg:hidden xl:flex" />
            <InfoItem label="response" value={responseTime} />

            {!!rating && (
              <>
                <div className="h-[4.75rem] w-0 shrink-0 border border-brand-fire-200 dark:border-brand-fire-200" />
                <InfoItem
                  label="reviews"
                  value={rating.toFixed(1)}
                  icon={
                    <Star className="my-auto aspect-square w-4 shrink-0 self-stretch object-contain" />
                  }
                  subValue={`${!!reviewCount} reviews`}
                />
              </>
            )}

            <div className="h-[4.75rem] w-0 shrink-0 border border-brand-fire-200 dark:border-brand-fire-200" />
            <InfoItem label="price" value={`${getCurrencySymbol(currency)}${price}`} />
          </div>
        </div>
        <div className="mt-6 flex w-full flex-wrap items-center justify-end gap-4 max-md:max-w-full">
          {/* Hide for future use */}
          {/* <Button
            variant="brand-secondary"
            size="md"
            label="View sample lesson"
            className="h-10 w-48"
          /> */}

          <Button
            variant="brand"
            size="md"
            label="Get started"
            className="h-10 w-32"
            onClick={handleGetStarted}
          />
        </div>
      </section>
    </>
  );
};

export default RemoteCoachingCard;
